module.exports = __webpack_public_path__ + "img/floorplan_1f.f2b3d468.jpg";